import axios from './http'
var qs = require('qs');

//新增6个接口 start
export function httpProcessMonitor(data) {
    return axios({
        url: '/client/applyform/applyform/process-monitor',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
export function httpIndexView(data) {
    return axios({
        url: '/client/visualized/index/view',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}


export function httpRealTime(data) {
    return axios({
        url: '/client/visualized/index/real-time',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}


export function httpUseRecord(data) {
    return axios({
        url: '/client/applyform/applyform/use-record',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
export function httpFormDetail(data) {
    return axios({
        url: '/client/applyform/applyform/details',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
export function httpScheduleSale(data) {
    return axios({
        url: '/client/applyform/applyform/schedule-sale',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//新增6个接口 end



//公共下拉框
export function httpCommonSelect(key) {
    let data = {
        key
    }
    return axios({
        url: '/client/common/select',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//公共下拉框
export function httpApplyformSelect() {
    return axios({
        url: '/client/applyform/applyform/select',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
    })
}
//检测项目
export function httpTestproject(data) {
    return axios({
        url: '/client/common/testproject',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//文件上传
export function httpUpload(data) {
    return axios({
        url: '/client/upload/upload/uploads',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: data
    })
}
//申请单添加
export function httpApplyformAdd(data) {
    return axios({
        url: '/client/applyform/applyform/add',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//申请单草稿添加
export function httpApplycopySave(data) {
    return axios({
        url: '/client/applyform/applycopy/save',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//草稿列表
export function httpApplycopy(page, pagesize, enterprise_client_name, product_name) {
    let data = {
        page,
        pagesize,
        enterprise_client_name,
        product_name
    }
    return axios({
        url: '/client/applyform/applycopy',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//草稿查看
export function httpApplycopyEdit(id) {
    let data = {
        id
    }
    return axios({
        url: '/client/applyform/applycopy/edit',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//未受理申请列表
export function httpApplycopyMyapply(page, pagesize) {
    let data = {
        page,
        pagesize
    }
    return axios({
        url: '/client/applyform/applyform/myapply',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//我的申请列表
export function httpApplycopyMysuccess(page, pagesize, activity, apply_number, enterprise_client_name, product_name) {
    let data = {
        page,
        pagesize,
        activity,
        apply_number,
        enterprise_client_name,
        product_name
    }
    return axios({
        url: '/client/applyform/applyform/mysuccess',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//我的申请查看
export function httpApplyformDetails(id) {
    let data = {
        id
    }
    return axios({
        url: '/client/applyform/applyform/details',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//可视化获取数据
export function httpVisualizedView(data) {
    return axios({
        url: '/adminapi/visualized/index/view',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
export function httpVisualizedRealTime(data) {
    return axios({
        url: '/adminapi/visualized/index/real-time',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}